import { render, staticRenderFns } from "./StatisticsViewDetail.vue?vue&type=template&id=bc08731a&scoped=true&"
import script from "./StatisticsViewDetail.vue?vue&type=script&lang=js&"
export * from "./StatisticsViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsViewDetail.vue?vue&type=style&index=0&id=bc08731a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc08731a",
  null
  
)

export default component.exports